import React, { DragEventHandler, useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import classNames from 'classnames';
import { selectFilledPhotoById, selectUrlForPhotoById } from '../../../_redux-photos';
import { PhotoPrintFrame } from '../../photo-print/PhotoPrintFrame';
import { PhotoPrintDesktopOverlay } from './PhotoPrintDesktopOverlay';
import { PhotoPrintQuantity } from './PhotoPrintQuantity';
import styles from './PhotoPrintDesktop.module.scss';

const _PhotoPrintDesktop = ({ id, photo, className, setDragDisabledOnGroup }: Props) => {

    const photoRef = useRef<HTMLImageElement>(null);
    const [isDragging, setIsDragging] = useState(false);

    const onDrag: DragEventHandler<HTMLDivElement> = useCallback(event => {

        event.dataTransfer.setData('photoId', id);
        event.dataTransfer.setData('groupId', photo.groupId);
        event.dataTransfer.setDragImage(
            photoRef.current!,
            0.5 * photoRef.current!.clientWidth,
            0.5 * photoRef.current!.clientHeight);

        setDragDisabledOnGroup(true);
        setIsDragging(true);

    }, [id, photo.groupId, setDragDisabledOnGroup]);

    const onDragEnd = () => {
        setDragDisabledOnGroup(false);
        setIsDragging(false);
    };

    const overlayClasses = classNames(styles.overlay, {
        [styles.overlayDisabled]: isDragging
    });

    return (
        <div className={classNames(styles.container, className)}>
            <PhotoPrintFrame photoId={id}
                ref={photoRef}
                disabled={photo.status === 'error'}
                onDragStart={onDrag}
                onDragEnd={onDragEnd}>

                {photo.status !== 'error' && (
                    <PhotoPrintDesktopOverlay photoId={id} className={overlayClasses} />
                )}
            </PhotoPrintFrame>

            {photo.status !== 'error' && (
                <PhotoPrintQuantity className={styles.input} photoId={id} />
            )}
        </div>
    );
};

type OwnProps = {

    id: string;
    className?: string;

    setDragDisabledOnGroup: (value: boolean) => void;
};

type Props = OwnProps & {
    url?: string;
    photo: PhotoPrintsJson.ProcessedPhoto;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    photo: selectFilledPhotoById(state, ownProps.id)!,
    url: selectUrlForPhotoById(state, ownProps.id)
});

export const PhotoPrintDesktop = connect(
    mapStateToProps
)(_PhotoPrintDesktop);